import { Component, OnDestroy } from '@angular/core';
import { TenantProvider } from '@app/@core/providers/tenant.provider';
import { AppState } from '@app/app.module';
import { TenantSettingModel } from '@app/shared/models/tenant-setting.model';
import {
  NbSidebarService,
  NbMenuService,
  NbMediaBreakpointsService,
} from '@nebular/theme';
import { Store } from '@ngrx/store';
import { FloatingScroll } from '@theme/directives/floating-scroll.directive';
import Jquery from 'jquery';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime, delay } from 'rxjs/operators';

@Component({
    selector: 'ngx-one-column-layout',
    styleUrls: ['./one-column.layout.scss'],
    templateUrl: './one-column.layout.html',
    standalone: false
})
export class OneColumnLayoutComponent implements OnDestroy {
  public sideBarCollapse: boolean = false;
  resizeSub: Subscription;
  private storeSubscription: Subscription;
  tenantSetting: TenantSettingModel;
  subDomain: string;
  showTenantLogo: boolean = true;
  private isCollapse: boolean = false;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private store: Store<AppState>,
    private tenantProvider: TenantProvider
  ) {
    const breakpoints = this.breakpointService.getBreakpointsMap();
    const scrollBarWidth = 17;
    const clientWidth = document.documentElement.clientWidth + scrollBarWidth;
    if (clientWidth < breakpoints.xl) {
      this.sideBarCollapse = !this.sideBarCollapse;
    }
    if (this.sideBarCollapse) {
      if (clientWidth < breakpoints.sm) {
        this.sidebarService.collapse('menu-sidebar');
        this.isCollapse = true;
        this.showTenantLogo = false;
      } else {
        this.sidebarService.compact('menu-sidebar');
        this.isCollapse = false;
      }
    }

    this.menuService
      .onSubmenuToggle()
      .pipe(delay(100))
      .subscribe(() => {
        this.updateSidebarIconNavigation();
      });

    // debounce resize events
    // emits when no resize firing within 200ms delay
    this.resizeSub = fromEvent(window, 'resize')
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.updateSidebarIconNavigation();
      });
    this.storeSubscription = this.store.select(x => x.tenantSetting).subscribe(x => {
      this.tenantSetting = x;
    });
    this.subDomain = this.tenantProvider.getSubdomain();
  }

  updateSidebarIconNavigation() {
    const compacted = document.getElementsByClassName('menu-sidebar compacted')
      .length;
    const collapsed = document.getElementsByClassName('menu-sidebar collapsed')
      .length;
    if (collapsed || compacted) {
      this.showTenantLogo = collapsed <= 0;
      this.isCollapse = collapsed > 0;
      this.sideBarCollapse = true;
    } else {
      this.showTenantLogo = true;
      this.sideBarCollapse = false;
    }
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.sideBarCollapse = !this.sideBarCollapse;

    if (this.isCollapse) {
      this.showTenantLogo = !this.sideBarCollapse;
    }

    this.horizontalScrollHandler();
    return false;
  }

  horizontalScrollHandler() {
    if (Jquery('.floatingScroll').length > 0) {
      setTimeout(() => {
        FloatingScroll.floatingScroll(Jquery('.floatingScroll'), 'update');
      });
    }
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  ngOnDestroy(): void {
    this.resizeSub.unsubscribe();
  }

  getImage() {
    if (this.tenantSetting) {
      return this.tenantSetting.logoPath;//`url(${this.tenantSetting.logoPath})`;
    } else {
      return '';
    }
  }
}
